export default __webpack_public_path__ + "static/media/lush_garden.6d0fc3b4.jpg";